export default function AssignmentMarksSkeleton() {
  return (
    <div className="py-6">
      <div className="mx-auto max-w-full px-5 lg:px-20">
        <div className="px-3 py-20">
          <ul className="assignment-status">
            <div className="h-4 bg-slate-700 rounded-full w-24" />
            <div className="h-4 bg-slate-700 rounded-full w-24" />
            <div className="h-4 bg-slate-700 rounded-full w-24" />
          </ul>
          <div className="overflow-x-auto mt-4">
            <table className="divide-y-1 divide-gray-600 w-full">
              <thead>
                <tr>
                  <th className="table-th">
                    <div className="h-3 bg-slate-700 rounded w-36" />
                  </th>
                  <th className="table-th">
                    <div className="h-3 bg-slate-700 rounded w-36" />
                  </th>
                  <th className="table-th">
                    <div className="h-3 bg-slate-700 rounded w-36" />
                  </th>
                  <th className="table-th">
                    <div className="h-3 bg-slate-700 rounded w-36" />
                  </th>
                  <th className="table-th">
                    <div className="h-3 bg-slate-700 rounded w-36" />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-600/50">
                <tr>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-36" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-24" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td input-mark">
                    <div className="h-3 bg-slate-700 rounded w-16" />
                    <div className="h-3 bg-slate-700 rounded w-16" />
                  </td>
                </tr>
                <tr>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-36" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-24" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td input-mark">
                    <div className="h-3 bg-slate-700 rounded w-16" />
                    <div className="h-3 bg-slate-700 rounded w-16" />
                  </td>
                </tr>
                <tr>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-36" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-24" />
                  </td>
                  <td className="table-td">
                    <div className="h-2 bg-slate-700 rounded w-48" />
                  </td>
                  <td className="table-td input-mark">
                    <div className="h-3 bg-slate-700 rounded w-16" />
                    <div className="h-3 bg-slate-700 rounded w-16" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
